import * as actionTypes from "constants/ActionTypes";

export function getIntegrators() {
  return {
    type: actionTypes.GET_INTEGRATORS.REQUEST,
  };
}

export function getIntegratorCompanies({ id, page, limit }) {
  return {
    type: actionTypes.GET_INTEGRATOR_COMPANIES.REQUEST,
    id,
    page,
    limit,
  };
}

export function getCompanyUser(id, integratorId) {
  return {
    type: actionTypes.GET_COMPANY_USER.REQUEST,
    id,
    integratorId,
  };
}



// WEBPACK FOOTER //
// ./app/actions/integrators/integrators.js